import { universalFields } from '../_shared/universal.js';
/**
 * custom-html — the escape hatch. A raw HTML/CSS `code` textarea the merchant can drop arbitrary markup
 * into (embeds, one-off promos). The render path ALWAYS sanitizes against the shared richtext allowlist
 * (the live XSS barrier); `allowIframe` additionally permits a NARROWLY allowlisted https-only `<iframe>`
 * (no scripts, sandboxed) for embeds (maps, videos) — see Component.tsx for the security posture. The
 * shared "Section" universal group controls scheme / padding / width.
 */
export const customHtmlSchema = {
    type: 'custom-html',
    name: 'Custom HTML',
    version: 1,
    templates: ['index', 'product', 'collection', 'page', 'thank-you'],
    fields: [
        // ── Content ─────────────────────────────────────────────────────────────
        {
            id: 'code',
            aiWritable: false, // 0059 — machine format, not prose
            type: 'textarea',
            label: 'HTML / CSS',
            group: 'Content',
            info: 'Sanitized on render. Scripts and event handlers are always stripped.',
            default: '<p>Votre contenu HTML ici.</p>',
            rows: 8,
            maxLength: 5000,
        },
        {
            id: 'allowIframe',
            type: 'checkbox',
            label: 'Allow embedded iframes',
            group: 'Content',
            info: 'Permits https-only sandboxed <iframe> embeds (maps, videos). Scripts stay blocked.',
            default: false,
        },
        // ── Section (universal) ──────────────────────────────────────────────────
        ...universalFields,
    ],
};
export const customHtmlPresets = [
    {
        name: 'Custom HTML',
        settings: {
            code: '<p>Votre contenu HTML ici.</p>',
            allowIframe: false,
        },
        blocks: [],
    },
];
/**
 * How this section presents itself in "Add section": label, group, icon.
 *
 * It lives beside the schema, NOT in `index.ts`, and that is the point. `index.ts` is the module that pulls
 * in `Component.tsx`, and the builder reads `meta` for all sixty-two sections to paint the picker while
 * rendering only the handful a page actually uses. Keeping `meta` here lets `registry.lazy.gen.ts` import it
 * without dragging every section's render code into the editor's entry chunk.
 */
export const customHtmlMeta = {
    label: 'Custom HTML',
    group: 'Advanced',
    icon: 'chat',
};
//# sourceMappingURL=schema.js.map